import React from "react";
import { Button, Grid } from "semantic-ui-react";
import { setBackgroundColor } from "../../Helpers";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";
import "../../styles/modal.scss";

interface IBCModalPrevNext {
  handlePrev?: any;
  handleCancel: any;
  handleNext?: any;
  handleSave?: any;
  brokerColor: string;
}

const BCModalPrevNext = ({ 
  handlePrev, 
  handleCancel, 
  handleNext, 
  handleSave, 
  brokerColor }: IBCModalPrevNext) => {
  return (
    <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            {handlePrev && <Button
              fluid 
              onClick={handlePrev}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Previous</div>
              </div>
            </Button>}
          </Grid.Column>
          <Grid.Column>
            <Button
              fluid 
              onClick={handleCancel}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">Cancel</div>
              </div>
            </Button>
          </Grid.Column>
          <Grid.Column>
            {(handleNext || handleSave) && <Button 
              className="bp-button" 
              style={getIsWhiteLabeled() ? setBackgroundColor(brokerColor ? brokerColor : "#000000") : void 0}
              fluid 
              onClick={handleNext || handleSave}
            >
              <div className="gmr-button-container">
                <div className="gmr-button-text">{handleNext ? "Next" : "Save"}</div>
              </div>
            </Button>}
          </Grid.Column>
        </Grid.Row>
      </Grid>
  );
};

export default BCModalPrevNext;
